import type { AxiosRequestConfig } from 'axios';
import { stringify } from 'qs';
import { catalogueRequestHeaders } from '~/utils/catalogueRequestHeaders';

const useApiPCFetch = () => {
  const { fetch: apiFetch } = useAPIFetch();
  const runtimeConfig = useRuntimeConfig();

  const fetch: <T>(config: AxiosRequestConfig, returnResponse?: boolean) => Promise<T> = (config) => {
    const params = { ...config.params };

    Object.keys(params).forEach((key) => {
      if (Array.isArray(params[key])) {
        const arrayValues = params[key];
        delete params[key];

        arrayValues.forEach((value, index) => {
          params[`${key}[${index}]`] = value;
        });
      }
    });

    const headerExtra =
      config.headers && typeof config.headers === 'object' && !Array.isArray(config.headers)
        ? (config.headers as Record<string, string>)
        : {};

    const catalogueBaseUrl = import.meta.client
      ? '/api/catalogue-proxy/'
      : runtimeConfig.public.propertyCatalogueApiUrl;

    return apiFetch({
      baseURL: catalogueBaseUrl,
      ...config,
      headers: {
        ...catalogueRequestHeaders(runtimeConfig.public.appUrl, runtimeConfig.public.propertyCatalogueRequestOrigin),
        ...headerExtra,
      },
      params: Object.fromEntries(new URLSearchParams(stringify(params))),
    });
  };

  return {
    fetch,
  };
};

export default useApiPCFetch;
